import React from 'react';
import ReactDOM from 'react-dom';

import { WhoisResultsPageLoader } from './WhoisResultsPage';

ReactDOM.render(<WhoisResultsPageLoader />, document.getElementById('root'));
